import React, { Component } from 'react'
import List from '../../../Container/Lists/List'
import DefaultPage from '../../../Container/Layout/DefaultPage'
import * as routes from '../../../constants/routes'
import InAppNav from '../../InAppNav/InAppNav'
import InputFilter from '../../../Container/Filter/InputFilter'
import { getAppUsers, handleDeativateUser } from '../../../firebase/database/handleUserMgm'
import Loading from '../../../Container/Loading/Loading'
import arraySort from 'array-sort'
class UserUnlocked extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            users: [],
            filteredUsers: null,
        };
    }

    async componentDidMount () {
        const users  = await getAppUsers()
       await this.setState({users: users})
       this.setState({loading: false})
    }

    deactivateUser = async (user) => {
        await handleDeativateUser(user)
        const confirmed = window.confirm('Den Benutzer ' + user.name + ' in ' + user.ort + ' wirklich deaktiveren? Es ist dann keine Anmeldung an der App mehr möglich')
        if(confirmed===false) return null
        const newUsers = await getAppUsers()
        this.setState({users: newUsers})

    }

    buttonConfig = {
            deactivateUser: [
                {
                    title: 'Benutzer Deaktivieren', 
                    onClick:this.deactivateUser
                }, 
            ],
    }

   
    render () {
        if(this.state.loading===true || this.state.users.length===0) return <Loading text='Daten werden geladen....' />
       return (
           <DefaultPage headline={{headlineText: 'Freigeschaltene App Benutzer'}}>
            <InAppNav links={[{name:'Admin Home', route: routes.ADMINHOME}]}/>
           
                 <InputFilter 
                    initList={this.state.users}
                    callback={(filteredList)=>this.setState({filteredUsers: filteredList})}
                    counter={this.state.filteredUsers!==null ? this.state.filteredUsers.length : null}
                    filterProps={['name', 'ort']}
                    filterActive={this.state.filteredUsers!==null}
                    />
                <List 
                    items={this.state.filteredUsers===null ? arraySort(this.state.users, 'name') : this.state.filteredUsers}
                    itemHeight={40}
                    headerProps={['Name', 'Ort', 'Email', 'Typ']}
                    renderProps={['name', 'ort', 'email', 'role']}
                   
                    buttons= {this.buttonConfig.deactivateUser}
                />
                
           </DefaultPage>
          
       )
    }
}


export default UserUnlocked


// WEBPACK FOOTER //
// ./src/Components/Admin/UserMgm/UserUnlocked.js